
const formatPhoneNumber = (phoneNumber) => {
    /*
        parameters:
            phoneNumber: str, expects only common phone number formats within U.S.  No country codes. (000) 000-0000 or 000-000-0000
        
        returns:
            str: "(000) 000-0000"
    */
    if (phoneNumber === undefined){
      return '';
    }
    let justNumbers = String(phoneNumber).split('').filter(char => !['-','(',')',' '].includes(char)).join('');
    let formattedArray = justNumbers.split('');
    return "("+formattedArray.slice(0,3).join("")+") "+formattedArray.slice(3,6).join("")+"-"+formattedArray.slice(-4).join("");
  }

  export default formatPhoneNumber;